export default async (context, data) => {
    let arr = data.arr
    await context.$store.dispatch('music/setMusic', {
        music: arr
    })
    context.$router.push('/video-editor')
}